import { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

import {
  Table,
  Icon,
  Alert,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  Chip,
  Spinner,
} from "design-react-kit";

import "../../assets/Table.css";
import TableSearch from "./TableSearch";
import TableHeader from "./TableHeader";
import {
  downloadFlow,
  filterHandler,
  showFlowType,
} from "../../services/helpers";
import AuthModuleErrorsModal from "../Modals/AuthModuleErrorsModal";
import UserContext from "../../store/user-context";
import { useSignIn, useSignOut } from "react-auth-kit";
import StagedFlowStatusEnum from "../../helpers/Enums/StagedFlowStatusEnum";
import AuthModuleConfirmModal from "../Modals/AuthModuleConfirmModal";

const AuthModuleFlowsWithFailedCalculationTable = ({
  items,
  columns,
  getFlows,
  filters,
}) => {
  const [results, setResults] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFlow, setSelectedFlow] = useState(null);
  const [authFlowErrorsModalOpen, setAuthFlowErrorsModalOpen] = useState(false);
  const [flowModalOpen, setFlowModalOpen] = useState(false);
  const [status, setStatus] = useState(null);
  const [text, setText] = useState(null);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  useEffect(() => {
    setResults(items);
    setFlowModalOpen(false);
  }, [items]);

  const authFlowErrorsModalOpenHandler = (flow) => {
    setAuthFlowErrorsModalOpen(true);
    setSelectedFlow(flow);
  };

  const authFlowErrorsModalCloseHandler = () => {
    setAuthFlowErrorsModalOpen(false);
    setSelectedFlow(null);
  };

  const flowModalOpenHandler = (flow, status, text) => {
    const dropdowns = document.querySelectorAll(".dropdown-menu");

    dropdowns.forEach((item) => item.classList.remove("show"));

    setSelectedFlow(flow);
    setStatus(status);
    setText(text);
    setFlowModalOpen(true);
  };

  const flowModalCloseHandler = () => {
    setSelectedFlow(null);
    setStatus(null);
    setFlowModalOpen(false);
  };

  return (
    <Fragment>
      {error !== null && error.length !== undefined && (
        <Alert color="danger" className="w-50 ml-auto mr-auto">
          {error.map((item) => (
            <p key={item}>{item}</p>
          ))}
        </Alert>
      )}

      {isLoading && (
        <p
          style={{
            height: "50px",
            position: "relative",
            marginBottom: "3rem",
          }}
        >
          <Spinner double active />
        </p>
      )}
      <div className="d-flex flex-column align-items-end justify-content-start">
        <div className="d-flex align-items-start justify-content-end w-100">
          <TableSearch
            items={items}
            filterHandler={filterHandler}
            setResults={setResults}
            text={"Cerca per nome del flusso"}
            column={"name"}
          />
          <span title="Aggiornare i dati della tabella">
            <Icon
              icon="it-refresh"
              fill="#06c"
              className="ml-3 mt-1 mb-2"
              type="button"
              onClick={(e) => getFlows(filters)}
            />
          </span>
        </div>
        <Table responsive className="table">
          <TableHeader
            columns={columns}
            setResults={setResults}
            items={items}
          />
          <tbody>
            {results !== null &&
              results !== undefined &&
              results.map((result) => {
                return (
                  <tr key={result.id}>
                    <td className="predispositionDate">
                      {result.predispositionDate}
                    </td>
                    <td className="name">{result.name}</td>
                    <td className="clientName">{result.clientCodeName}</td>
                    <td className="flowType">
                      {showFlowType(result.flowType)}
                    </td>
                    <td className="status text-center">
                      <span
                        style={{ cursor: "pointer" }}
                        title={result.stagedFlowStatusLabel}
                        onClick={(e) => authFlowErrorsModalOpenHandler(result)}
                      >
                        <Chip
                          color="danger"
                          className="text-nowrap"
                          role="button"
                        >
                          {result.stagedFlowStatusLabel}
                        </Chip>
                      </span>
                    </td>
                    <td className="text-center notCalculatedFlowsDropdown">
                      <UncontrolledDropdown className="table-dropdown">
                        <DropdownToggle>
                          <Icon icon="it-more-actions" fill="#06c" />
                          <Link to={null} className="moreActions">
                            Vedi azioni
                          </Link>
                        </DropdownToggle>
                        <DropdownMenu>
                          <div className="d-flex align-items-center ml-3 mr-2">
                            <Icon icon="it-error" fill="#06c" />
                            <Link
                              to={null}
                              className="trasmetti"
                              onClick={(e) =>
                                authFlowErrorsModalOpenHandler(result)
                              }
                            >
                              Dettaglio errori
                            </Link>
                          </div>
                          <hr />
                          <div
                            className="d-flex align-items-center ml-3"
                            style={{ cursor: "pointer" }}
                          >
                            <Icon icon="it-download" fill="#06c" />
                            <Link
                              to={null}
                              className="download text-nowrap"
                              onClick={(e) =>
                                downloadFlow(
                                  "DownloadFlow",
                                  result.id,
                                  setIsLoading,
                                  signIn,
                                  signOut,
                                  navigate,
                                  userContext,
                                  setError,
                                )
                              }
                            >
                              Scarica flusso (dati)
                            </Link>
                          </div>
                          <div
                            className="d-flex align-items-center ml-3"
                            style={{ cursor: "pointer" }}
                          >
                            <Icon icon="it-download" fill="#06c" />
                            <Link
                              to={null}
                              className="download text-nowrap"
                              onClick={(e) =>
                                downloadFlow(
                                  "DownloadDocuments",
                                  result.id,
                                  setIsLoading,
                                  signIn,
                                  signOut,
                                  navigate,
                                  userContext,
                                  setError,
                                )
                              }
                            >
                              Scarica flusso (allegati)
                            </Link>
                          </div>
                          <hr />
                          <div
                            style={{ cursor: "pointer" }}
                            className="d-flex align-items-center ml-3"
                          >
                            <Icon role="button" icon="it-refresh" fill="#06c" />
                            <Link
                              to={null}
                              className="reelaborate"
                              onClick={(e) =>
                                flowModalOpenHandler(
                                  result,
                                  StagedFlowStatusEnum.ReadyForCalculation,
                                  "Confermi la richiesta di effettuare un nuovo ricalcolo costi?",
                                )
                              }
                            >
                              Ricalcola costi
                            </Link>
                          </div>
                          <div
                            style={{ cursor: "pointer" }}
                            className="d-flex align-items-center ml-3"
                          >
                            <Icon role="button" icon="it-delete" fill="#06c" />
                            <Link
                              to={null}
                              className="reelaborate text-nowrap"
                              onClick={(e) =>
                                flowModalOpenHandler(
                                  result,
                                  StagedFlowStatusEnum.NotValidForPriceCalculation,
                                  "Confermi la richiesta di effettuare una validazione extra?",
                                )
                              }
                            >
                              Richiedi validazione extra
                            </Link>
                          </div>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>
                  </tr>
                );
              })}
            <AuthModuleErrorsModal
              modalOpen={authFlowErrorsModalOpen}
              modalCloseHandler={authFlowErrorsModalCloseHandler}
              selectedFlow={selectedFlow}
              isArchivePage={false}
            />

            {results !== null && results.length === 0 && (
              <tr>
                <td colSpan={12}>
                  <Alert className="w-50 mx-auto" color="info">
                    Nessun risultato trovato!
                  </Alert>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
        <AuthModuleConfirmModal
          confirmModalOpen={flowModalOpen}
          confirmModalCloseHandler={flowModalCloseHandler}
          stagedFlowId={selectedFlow?.id}
          target={selectedFlow?.name}
          error={error}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setError={setError}
          getFlows={getFlows}
          status={status}
          filters={filters}
          text={text}
        />
      </div>
    </Fragment>
  );
};

export default AuthModuleFlowsWithFailedCalculationTable;
